import Layout from '@/apps/bRem/Layouts/Layout.vue'
import bRemDash from '@/apps/bRem/views/bRemDash.vue'
import bRemSetting from '@/apps/bRem/views/bRemSetting.vue'
export default [
	{
		path: '/bRem',
		folder: Layout,
		meta: {requiresAuth: true},
		children: [
			{
				path: '/',
				name:'bRem',
				folder: bRemDash
			},
			{
				path: 'Setting',
				name:'bRemSetting',
				folder: bRemSetting
			},
		]
	}
]
